import { observer } from "mobx-react-lite";
import { useGeneralMapStore } from "../stores/GeneralMapStoreContext";
import { cn } from "@/lib/utils";
import { CUSTOM_FILTERS } from "@/config/list";

const ACTIVITY_OPTIONS: { label: string; value: string }[] = [
	{ label: "Active", value: "active" },
	{ label: "Deactivated", value: "inactive" },
	{ label: "All", value: "all" },
];

export const ActivityFilter = observer(() => {
	const { mapStore } = useGeneralMapStore();
	const { filters } = mapStore;
	const value = (filters.getFilter(CUSTOM_FILTERS.isActive) as string | undefined) ?? "active";

	const onSelect = (selected: string) => {
		if (selected === "active") {
			filters.clear(CUSTOM_FILTERS.isActive);
		} else {
			filters.setFilter(CUSTOM_FILTERS.isActive, selected);
		}
	};

	return (
		<div className="space-y-1.5 pt-1">
			<span className="text-xs font-medium text-gray-700">Activity</span>
			<div className="flex flex-wrap gap-1.5">
				{ACTIVITY_OPTIONS.map(option => {
					const isSelected = option.value === value;
					return (
						<button
							key={option.value}
							onClick={() => onSelect(option.value)}
							className={cn(
								"inline-flex items-center gap-1.5 px-2 py-1 rounded-full text-xs font-medium transition-colors border",
								isSelected
									? "border-transparent bg-gray-900 text-white"
									: "border-gray-200 text-gray-600 bg-white hover:bg-gray-50",
							)}
						>
							{option.label}
						</button>
					);
				})}
			</div>
		</div>
	);
});
